import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction, refreshBoards } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { List, Row, Cell } from '../../../../components/List';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { formatCurrency } from '../../../../utils/string';
import { updateInvoiceStatus } from '../../../Invoices/actions';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { getRemarkType } from '../helpers/getRemarkType';

import styles from './WS_Default.module.css';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { KanbanRemarksCard } from '../../../Vehicles/components/KanbanRemarksCard';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
  'final-inspection-data': false,
};

const TASK_REMARK_TYPE = 'eindinspectie';

/* eslint-disable react/prefer-stateless-function */
class WS_FINAL_INSPECTIONComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        {this.renderModalBody()}
      </ModalComponent>
    );
  }

  showDoneTasks(vehicle) {
    const fields = [
      'task_desticker_done',
      'task_nijboer_done',
      'task_AVN_done',
      'task_polish_exterior_done',
      'task_interior_polish_done',
      'task_interior_repair_done',
      'task_int_ext_polish_done',
      'task_restyle_done',
      'task_spot_repair_done',
      'task_spray_done',
      'task_window_repair_done',
      'task_repair_done',
      'task_service_done',
      'task_recall_done',
      'task_apk_done',
      'task_adjust_done',
      'task_attach_parts_done',
      'task_hartstad_done',
      'task_ijsseldelta_done',
      'HILT_repair_order_done',
      'action_ws1_preinspection_done',
      'task_attach_replate_done',
    ];

    return fields.filter(field => vehicle[field] == '1' || vehicle[field] === 1).map(field => field.replace(/_done$/, ''));
  }

  renderModalBody() {
    if (this.state.loading) return <Loader />;
    return (
      <WithVehicle vehicle_id={this.vehicle.id} loader>
        <VehicleHeader vehicle={this.vehicle} />
        <div className="pane"></div>
        {this.vehicle ? (
          <VBox center>
            <Row>
              <Cell>{this.lbl(`vehicle.property.tasks_done`)}</Cell>
              <Cell>
                {this.showDoneTasks(this.vehicle).map((task, i) => (
                  <div key={i}>{this.lbl(`vehicle.property.${task}`)}</div>
                ))}
              </Cell>
            </Row>

            <Row></Row>
          </VBox>
        ) : null}

        <div className="d-flex gap-2 mt-2">
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </WithVehicle>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.final_inspection_counter} ranges={ranges}>
            {vehicle?.final_inspection_counter || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}

                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }
}

WS_FINAL_INSPECTIONComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    invoicePaid(invoiceId, callback) {
      dispatch(updateInvoiceStatus(invoiceId, 2, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS_FINAL_INSPECTION = compose(withConnect, withRouter)(WS_FINAL_INSPECTIONComp);
